import { ApplicationsDeleteState } from '../reducers/applications-delete.reducer';
import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { applicationsDeleteActions } from '../actions';
import {
  selectApplicationsDeleteData,
  selectApplicationsDeleteError,
  selectApplicationsDeleteLoading,
} from '../selectors';

@Injectable()
export class ApplicationsDeleteFacade {
  private readonly store: Store<ApplicationsDeleteState> = inject(Store);

  public delete(applicationId: string): void {
    this.store.dispatch(applicationsDeleteActions.delete({ applicationId }));
  }

  public selectData(): Signal<any> {
    return this.store.selectSignal(selectApplicationsDeleteData);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsDeleteLoading);
  }

  public selectError(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsDeleteError);
  }

  public clearStore(): void {
    this.store.dispatch(applicationsDeleteActions.clearStore());
  }
}
